import { Row, Spinner } from "@narmi/design_system";

import styles from "./InternationalWireForm.module.scss";

import type { SwiftInstitution } from "byzantine/src/dbbl/businessLogic/modules/recipientDrawer";

interface InstitutionDetailsProps {
  isLoading: boolean;
  institution: SwiftInstitution | null;
}

// the bank a SWIFT BIC belongs to, shown under the BIC
const InstitutionDetails = ({
  isLoading,
  institution,
}: InstitutionDetailsProps) => {
  if (isLoading) {
    return (
      <Row className="margin--top--xs">
        <Spinner size={22} color="var(--theme-secondary)" />
      </Row>
    );
  }
  if (!institution) return null;
  return (
    <Row className={`margin--top--xs ${styles.institutionDetails}`}>
      <Row.Item className={styles.bankNameContainer}>
        <span className="narmi-icon-bank" />
        <span
          className={`fontColor--secondary ${styles.bankName}`}
          title={institution.name}
        >
          {institution.name}
        </span>
      </Row.Item>
      <Row.Item shrink>
        <span className="fontColor--secondary">{institution.location}</span>
      </Row.Item>
    </Row>
  );
};

export default InstitutionDetails;
